import { Injectable } from "@angular/core";
import { Actions, concatLatestFrom, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { TelemetryService } from "@obg/ngx.global";
import { RouteSelector } from "@obg/ngx.router";
import { filter, tap } from "rxjs/operators";

import { DGA_AUTH_TRANSACTION_ACTION_TYPE } from "../../auth-transaction/dga/dga-auth-transaction.action";
import { NemIdAuthTransactionRequest } from "../../auth-transaction/dga/dga-auth-transaction.model";
import { CORE_ROUTE } from "../../route";
import { CoreState } from "../../state";
import { AuthTelemetryEventName } from "../auth/auth-telemetry.model";

@Injectable()
export class DgaAuthTransactionTelemetryEffect {
	initializeAuthTransaction$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(DGA_AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransaction),
				concatLatestFrom(() => this.store.select(RouteSelector.getCurrent)),
				filter(([, current]) => current?.name !== CORE_ROUTE.registration.register),
				tap(([action]) => {
					this.service.track({
						event: AuthTelemetryEventName.LoginSubmitted,
						LoginMethod: (action as ActionWithPayload<NemIdAuthTransactionRequest>).payload
							.authenticationType,
					});
				})
			),
		{ dispatch: false }
	);
	constructor(
		private actions$: Actions,
		private service: TelemetryService,
		private store: Store<CoreState>
	) {}
}
